import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { useCopyAPIKeyIntegration } from '../CopyAPIKeyModal/useCopyAPIKeyIntegration';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
import CountLogo from './CountLogo';
export const GetCountCardTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            CountCardTID: {
                Card: 'count-card',
                Connect: 'count-card-connect'
            }
        }
    });
export default function CountCard() {
    const { showCopyAPIKeyModal } = useCopyAPIKeyIntegration('count');
    const { t: countTexts } = useLocaleKeys('integrations.count');
    const { CountCardTID } = useMemo(()=>GetCountCardTID(), []);
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: CountCardTID.Card(),
        icon: /*#__PURE__*/ _jsx(CountLogo, {}),
        title: countTexts.title(),
        subTitle: countTexts.subTitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            bi: {
                name: 'connect_count'
            },
            onClick: showCopyAPIKeyModal,
            testId: CountCardTID.Connect(),
            children: countTexts.connect()
        })
    });
}
